import { Autocomplete, TextField, Typography } from '@mui/material';
import useLocationList from 'api/homePage/useLocationList/useLocationList';
import useLocationZone from 'api/locationZone/useLocationZone/useLocationZone';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';

const WarehouseOperationDefaultSettings = () => {
  const [{ operationSettings }, setCookie, removeCookie] = useCookies([
    'operationSettings',
  ]);

  const [getLocationList, locationsLoading, locationList] = useLocationList({
    notTable: true,
  });
  const [getZonesList, zonesLoading, zonesList] = useLocationZone();
  const [selectedLocation, setSelectedLocation] = useState(
    operationSettings?.defaultLocation,
  );
  const [selectedZone, setSelectedZone] = useState(
    operationSettings?.defaultZone,
  );

  useEffect(() => {
    getLocationList();
  }, []);

  useEffect(() => {
    if (selectedLocation?.key) {
      getZonesList({}, { notTable: true, locationGuid: selectedLocation?.key });
      setCookie(
        'operationSettings',
        {
          defaultLocation: selectedLocation,
          defaultZone: null,
        },
        {
          path: '/',
          expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        },
      );
    } else {
      setCookie(
        'operationSettings',
        {
          defaultLocation: null,
          defaultZone: null,
        },
        {
          path: '/',
          expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        },
      );
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (selectedZone?.key) {
      getZonesList({}, { notTable: true, locationGuid: selectedLocation?.key });
      setCookie(
        'operationSettings',
        {
          defaultLocation: selectedLocation,
          defaultZone: selectedZone,
        },
        {
          path: '/',
          expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        },
      );
    } else {
      setCookie(
        'operationSettings',
        {
          defaultLocation: selectedLocation,
          defaultZone: null,
        },
        {
          path: '/',
          expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        },
      );
    }
  }, [selectedZone]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        backgroundColor: '#eeeeee',
        borderRadius: 15,
        padding: 20,
        paddingRight: 30,
        paddingLeft: 40,
        gap: 18,
      }}
    >
      <div style={{ flex: 1, marginBottom: '32px' }}>
        <Typography>تنظیمات پیش‌فرض عملیات انبار</Typography>
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ width: '360px' }}>
          <Autocomplete
            options={locationList || []}
            autoHighlight
            disableClearable
            loading={locationsLoading}
            value={selectedLocation || null}
            getOptionLabel={option => option.value}
            noOptionsText={
              <div className="w-full flex justify-center">موردی یافت نشد</div>
            }
            renderOption={(args, option) => (
              <div {...args} dir="rtl">
                {option.value}
              </div>
            )}
            onChange={(event, newValue) => {
              setSelectedLocation(prev => newValue);
            }}
            sx={{
              '.MuiInputBase-root': {
                paddingRight: '9px !important',
              },
            }}
            renderInput={params => (
              <TextField
                {...params}
                sx={{
                  '.MuiAutocomplete-endAdornment': {
                    right: 'unset !important',
                    left: '9px',
                  },
                  '.MuiAutocomplete-endAdornment button': {
                    mr: 0.5,
                  },
                }}
                label="انتخاب انبار پیش‌فرض"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'zone', // disable autocomplete and autofill
                }}
                className="gray-icon"
                InputProps={{
                  ...params.InputProps,
                }}
              />
            )}
          />
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ width: '360px' }}>
          <Autocomplete
            options={zonesList || []}
            autoHighlight
            disableClearable
            loading={zonesLoading}
            value={selectedZone || null}
            getOptionLabel={option => option.value}
            noOptionsText={
              <div className="w-full flex justify-center">موردی یافت نشد</div>
            }
            renderOption={(args, option) => (
              <div {...args} dir="rtl">
                {option.value}
              </div>
            )}
            onChange={(event, newValue) => {
              setSelectedZone(prev => newValue);
            }}
            sx={{
              '.MuiInputBase-root': {
                paddingRight: '9px !important',
              },
            }}
            renderInput={params => (
              <TextField
                {...params}
                sx={{
                  '.MuiAutocomplete-endAdornment': {
                    right: 'unset !important',
                    left: '9px',
                  },
                  '.MuiAutocomplete-endAdornment button': {
                    mr: 0.5,
                  },
                }}
                label="انتخاب سالن پیش‌فرض"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'zone', // disable autocomplete and autofill
                }}
                className="gray-icon"
                InputProps={{
                  ...params.InputProps,
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default WarehouseOperationDefaultSettings;
